import React, { Component } from "react";
import { Card, Layout } from "antd";
const { Header, Footer, Sider, Content } = Layout;

const pStyle = {
  display: "inline-block",
  verticalAlign: "top",
  marginBottom: 0,
  marginTop: '5px',
  padding: '0 5px',
  width: '43%',
  opacity: '.9',
  fontWeight: 600
};

export const PanelComponent = props => {
  return (
    <Card
      size="small"
      title={props.title}
      extra={<a href="#">#</a>}
      style={{ padding: "5px" }}
    >
      <p style={pStyle}>Source</p>
      <p style={pStyle}>Destination</p>
      {props.children}
    </Card>
  );
};



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panel/PanelComponent.js